/**
 * Date validator
 * Analyze if string is a date valid.
 * @param { String } value - Date entered must follow Brazilian standard
 * @example 'DD/MM/YYYY is a Valid date.'
 * @example 'MM/DD/YYYY is a Invalid date.'
 * @return { Boolean } is a valid date
 */
const date = (value, futureDate = false, optional = false) => {
  if (optional && (value === '' || !value)) {
    return true
  }

  if (!value) return false

  const dateRegex = /([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/g
  if (!value.match(dateRegex)) return false

  // Convert brazilian format to global format => DD/MM/YYYY => MM/DD/YYYY
  const normalized = value.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, '$2/$1/$3')
  const birthDate = new Date(normalized)

  const nowDate = new Date(Date.now())

  if (birthDate.toString() === 'Invalid Date') return false

  const [month, day, year] = normalized.split('/')
  if (
    birthDate.getFullYear() !== parseInt(year, 10) ||
    birthDate.getMonth() !== parseInt(month - 1, 10) ||
    birthDate.getDate() !== parseInt(day, 10)
  ) {
    return false
  }

  if (!futureDate) {
    if (birthDate > nowDate) return false
  }

  return true
}

export { date }
export default date
